var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Row', {
    staticClass: "section-first"
  }, [_c('Col', {
    attrs: {
      "offset": "4",
      "span": "10"
    }
  }, [_c('h1', [_vm._v("科隆云")]), _c('h2', [_vm._v("科隆智谷一体化管理平台")]), _c('h3', [_vm._v(" 一个集齐工业自动化、客户管理、配方管理的一站式化工行业的专业管理系统 ")]), _c('Button', {
    attrs: {
      "size": "large",
      "type": "primary",
      "to": "/signup"
    }
  }, [_vm._v("免费注册")]), _c('Button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "size": "large",
      "to": "/login"
    }
  }, [_vm._v("登录")])], 1)], 1), _vm._m(0)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "footer"
  }, [_c('span', [_vm._v("© 2024 深圳市智达万物物联网有限公司")]), _c('a', {
    staticClass: "icptext",
    attrs: {
      "target": "blank",
      "href": "http://beian.miit.gov.cn"
    }
  }, [_vm._v(" | 粤ICP备19057831号")])]);

}]

export { render, staticRenderFns }